import { useState } from 'react';

export interface ShowSamplesDetailsState {
  dateFrom: string;
  dateTo: string;
  defectSetId: string;
  deviceId: string;
  features?: Record<string, string[]>;
}

const useShowSamplesDetails = () => {
  const [showDetails, setShowDetails] = useState<null | ShowSamplesDetailsState>(null);
  const [searchVersion, setSearchVersion] = useState(0);

  const runShowDetailsSearch = (nextShowDetails: ShowSamplesDetailsState) => {
    setShowDetails(nextShowDetails);
    setSearchVersion(previousVersion => previousVersion + 1);
  };

  return { runShowDetailsSearch, searchVersion, setShowDetails, showDetails };
};

export default useShowSamplesDetails;
